"use client";

import type { ResolvedHeaderAction } from "@/utils/header-actions";
import type { NavigationBreakpoint } from "@/hooks/useMinWidth";
import HeaderActionItem, { type HeaderActionIcons } from "./HeaderActionItem";

/** The header's action area from `layout.header.actions`; mobile placements are applied below `bp`. */
export default function HeaderActions({
  actions,
  bp,
  icons,
  onSearch,
}: {
  actions: ResolvedHeaderAction[];
  bp: NavigationBreakpoint;
  icons?: HeaderActionIcons;
  onSearch?: () => void;
}) {
  if (!actions.length) return null;
  return (
    <div className="re-nav-actions" data-bp={bp}>
      {actions.map((action) => (
        <HeaderActionItem
          key={action.key}
          action={action}
          placement="bar"
          icons={icons}
          onSearch={onSearch}
        />
      ))}
    </div>
  );
}
